import { http } from "../../utils/config";

const voiceIpAPI = {
    getAccount: () => http.get("/api/v1/voicecalls/config"),

    updateOrCreate: (accountData) => http.post("/api/v1/voicecalls/config", accountData),

    deleteAccount: () => http.delete("/api/v1/voicecalls/config"),

    callToCustomer: (id) => http.get(`/api/v1/voicecalls/call-to-customer/${id}`),

    getHistories: (params = {}) => {
        const {
            page = 1,
            per_page = 10,
            search = '',
            start_date = '',
            end_date = '',
            status = '',
            phone = ''
        } = params;

        const queryParams = new URLSearchParams({
            page: page.toString(),
            per_page: per_page.toString(),
            status,
            ...(search && { search }),
            ...(phone && { phone }),
            ...(start_date && { start_date }),
            ...(end_date && { end_date })
        });

        return http.get(`/api/v1/voicecalls/call-histories?${queryParams}`);
    },

    initSip: () => http.get("/api/v1/voicecalls/init-sip"),
};

// Error handling wrapper
export const withErrorHandling = (apiFunction) => {
    return async (...args) => {
        try {
            const response = await apiFunction(...args);
            return response.data;
        } catch (error) {
            console.error("API Error:", error);

            if (error.response) {
                const { status, data } = error.response;
                switch (status) {
                    case 400:
                        throw new Error(data.message || "Dữ liệu không hợp lệ");
                    case 401:
                        throw new Error("Bạn cần đăng nhập để thực hiện thao tác này");
                    case 403:
                        throw new Error("Bạn không có quyền thực hiện thao tác này");
                    case 404:
                        throw new Error("Không tìm thấy thông tin");
                    case 422:
                        throw new Error(data.message || "Dữ liệu không hợp lệ");
                    case 500:
                        throw new Error(data.message || "Lỗi server, vui lòng thử lại sau");
                    default:
                        throw new Error(data.message || "Đã có lỗi xảy ra");
                }
            } else if (error.request) {
                throw new Error("Không thể kết nối đến server");
            } else {
                throw new Error(error.message || "Đã có lỗi xảy ra");
            }
        }
    };
};

// Wrapped API with error handling
export const voiceIpAPIWithErrorHandling = {
    getAccount: withErrorHandling(voiceIpAPI.getAccount),
    updateOrCreate: withErrorHandling(voiceIpAPI.updateOrCreate),
    deleteAccount: withErrorHandling(voiceIpAPI.deleteAccount),
    callToCustomer: withErrorHandling(voiceIpAPI.callToCustomer),
    getHistories: withErrorHandling(voiceIpAPI.getHistories),
    initSip: withErrorHandling(voiceIpAPI.initSip),
};

export default voiceIpAPI;
